/**
 * Payer partner UUIDs — identifies who pays for a member's subscription.
 *
 * `CASH_PAY` = the patient pays out of pocket; the others are benefit payers
 * (insurer/employer). A member's active payer id is
 * `partner.payers.current.partner.id`.
 */
export enum PayerId {
  CASH_PAY = "79a815d6-262c-46e4-a20d-d942b79f8fee",
  TRANSCARENT = "9c201a22-bd05-41c8-b885-ab17b1c73330",
  EVERNORTH = "2c31438e-af1e-4401-a676-6925227992d2",
  GEORGIA = "3a437954-5990-4359-86e4-a4d877a012f6"
}
